import useDeepCompareEffect from 'use-deep-compare-effect';
import { reportViewEvent, ReportViewEventArgs } from '../tracking/tracking';

export const useReportViewEvent = (args: ReportViewEventArgs): void => {
  useDeepCompareEffect(() => {
    reportViewEvent(args);
  }, [args]);
};
